import { bindActionCreators, } from 'redux'
import { connect, } from 'react-redux'

import {
  isMagicDrawerOpen,
} from 'redux/reducers'
import {
  closeMagicDrawer,
} from 'redux/actions'

import Component from './component'

const mapStateToProps = state => ({
  drawerOpen: isMagicDrawerOpen(state),
})
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      closeMagicDrawer,
    },
    dispatch
  ),
})

export default connect(mapStateToProps, mapDispatchToProps)(Component)



// WEBPACK FOOTER //
// ./src/components/MagicDrawer/index.js